import { useState, useCallback, useEffect } from "react";
import { TechAvailabilityResponse } from "../../../Interface/scheduler/form";

export const useTechAvailabilityManager = (
  initialScheduleCollection: TechAvailabilityResponse[]
) => {
  const [techAvailability, setTechAvailability] = useState<
    TechAvailabilityResponse[]
  >(initialScheduleCollection);

  // Update local state when prop changes
  useEffect(() => {
    setTechAvailability(initialScheduleCollection);
  }, [initialScheduleCollection]);

  const handleUpdateTechAvailability = useCallback(
    (newAvailability: TechAvailabilityResponse[]) => {
      setTechAvailability(newAvailability);
    },
    []
  );

  const appendTechAvailability = useCallback(
    (additionalAvailability: TechAvailabilityResponse[]) => {
      setTechAvailability((prev) => [...prev, ...additionalAvailability]);
    },
    []
  );

  return {
    techAvailability,
    handleUpdateTechAvailability,
    appendTechAvailability,
  };
};
